module.exports = __webpack_public_path__ + "img/c5201909-2.40242320.jpg";